/**
 * Company: SPHMedia
 * Description: Custom hook for managing video package state
 */

import { useState } from "react";

import { Variant } from "../types/MediaVariant.d";

type SelectedVideo = {
  source: string;
  variant: Variant;
};

type useVideoPackageData = {
  selectedVideo?: SelectedVideo;
  visible: boolean;
  openVideoDialog: (source: string, variant: Variant) => void;
  closeVideoDialog: () => void;
};

/**
 * Custom React Hook: useVideoPackageHook
 * Description: Custom hook for managing video package state
 * @param props - The props required by the hook (if any)
 * @returns data - The data returned by the hook
 */
export default function useVideoPackage(): useVideoPackageData {
  const [selectedVideo, setSelectedVideo] = useState<SelectedVideo>();
  const [visible, setVisible] = useState(false);

  const openVideoDialog = (source: string, variant: Variant) => {
    setSelectedVideo({ source, variant });
    setVisible(true);
  };

  const closeVideoDialog = () => {
    setVisible(false);
  };

  return { selectedVideo, visible, openVideoDialog, closeVideoDialog };
}
